import React, { useState } from 'react';
import {
  Paper, Typography, Box, Button, Stack, Alert, Chip, Divider,
} from '@mui/material';
import { Code as CodeIcon } from '@mui/icons-material';
import { useBuild } from '../../contexts/BuildContext';
import BackendCallDialog from '../../components/BackendCallDialog';

const HydrationInfoColumn = () => {
  const { hydrationResults, hydrationLastCall } = useBuild();
  const [open, setOpen] = useState(false);

  const stats = hydrationResults?.result?.stats;
  const tookBackend = hydrationResults?.result?.took_backend;
  const error = hydrationResults?.error;

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>Run info</Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          <Typography variant="caption">{error}</Typography>
        </Alert>
      )}

      {hydrationLastCall ? (
        <Stack spacing={2}>
          <Box>
            <Typography variant="caption" color="text.secondary">Endpoint</Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
              {hydrationLastCall.endpoint}
            </Typography>
          </Box>

          {tookBackend != null && (
            <Box>
              <Typography variant="caption" color="text.secondary">Latency</Typography>
              <Typography variant="body2">{tookBackend} ms</Typography>
            </Box>
          )}

          {stats && (
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                Items
              </Typography>
              <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                <Chip size="small" label={`in ${stats.items_in ?? 0}`} variant="outlined" />
                <Chip size="small" label={`returned ${stats.items_returned ?? 0}`} variant="outlined" />
              </Stack>
              <Divider sx={{ my: 1.5 }} />
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                Targets
              </Typography>
              {Object.entries(stats.targets || {}).map(([target, t]) => (
                <Stack key={target} direction="row" spacing={1} sx={{ mb: 0.5 }} alignItems="center">
                  <Typography sx={{ fontFamily: 'monospace', flexGrow: 1, fontSize: 12 }}>
                    {target}
                  </Typography>
                  <Chip size="small" color="success" variant="outlined"
                        label={`+${t.populated ?? 0}`} />
                  <Chip size="small" color="default" variant="outlined"
                        label={`${t.empty ?? 0} empty`} />
                </Stack>
              ))}
            </Box>
          )}

          <Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<CodeIcon />}
              onClick={() => setOpen(true)}
              fullWidth
            >
              View backend call
            </Button>
          </Box>
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Click <strong>Execute hydration</strong> to run.
        </Typography>
      )}

      <BackendCallDialog
        open={open}
        onClose={() => setOpen(false)}
        apiCall={hydrationLastCall}
      />
    </Paper>
  );
};

export default HydrationInfoColumn;
